import React from 'react'
import { Drawer } from 'antd'
import type { DrawerProps } from 'antd'

export interface DetailDrawerProps extends DrawerProps {
  children: React.ReactNode
}

export const DetailDrawer: React.FC<DetailDrawerProps> = ({
  width = 680,
  children,
  placement = 'right',
  destroyOnClose = true,
  ...restProps
}) => {
  return (
    <Drawer
      width={width}
      placement={placement}
      destroyOnClose={destroyOnClose}
      styles={{
        body: { padding: '24px' },
        header: { borderBottom: '1px solid rgba(255, 255, 255, 0.08)' },
      }}
      {...restProps}
    >
      {children}
    </Drawer>
  )
}

export default DetailDrawer
